import axios from 'axios'

/* ============================
   INSTANCIA DE AXIOS
============================ */

const urlApiBase = `https://api.tulxy.com/`
const urlApi = `${urlApiBase}api/`

const api = axios.create({
  baseURL: urlApi,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  }
})

/* ============================
   MÉTODOS PARA GESTIÓN DE TOKENS
============================ */
function getAccessToken() {
  return localStorage.getItem('access_token')
}

function getRefreshToken() {
  return localStorage.getItem('refresh_token')
}

function saveAccessToken(token) {
  localStorage.setItem('access_token', token)
}

function saveTokens({ access, refresh }) {
  localStorage.setItem('access_token', access)
  localStorage.setItem('refresh_token', refresh)
}

function isTokenExpired(token, offsetSeconds = 60) {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]))
    const exp = payload.exp
    const now = Math.floor(Date.now() / 1000)

    // Si expira en menos de offsetSeconds → lo consideramos caducado
    return exp - now < offsetSeconds
  } catch (e) {
    return true // si no se puede decodificar, lo tratamos como caducado
  }
}

/* ============================
   PETICIÓN DE LOGIN (sin token)
============================ */
async function getNewToken() {
  // 👉 AJUSTAR A TU ENDPOINT REAL
  const res = await axios.post(urlApi + 'account/auth/user/token/', {
    email: 'api@tulxy.com',   // 👉 AJUSTAR
    password: 'testpassword123'    // 👉 AJUSTAR
  })

  // Debe devolver { access, refresh }
  return res.data
}

/* ============================
   SISTEMA PARA COLA DE PETICIONES
   MIENTRAS REFRESCA EL TOKEN
============================ */

/* ============================
   INTERCEPTOR DE REQUEST
============================ */
api.interceptors.request.use(async (config) => {
  let token = getAccessToken()

  // 1. No hay token → login
  if (!token) {
    const tokens = await getNewToken()
    saveTokens(tokens)
    token = tokens.access
  }

  // 2. Token existe → comprobar si caducado o por caducar
  if (isTokenExpired(token)) {
    console.log("Token caducado o a punto de caducar → refrescando...")

    try {
      const refresh = getRefreshToken()

      const res = await axios.post(urlApi + 'account/auth/user/token/refresh/', {
        refresh
      })

      const newToken = res.data.access
      saveAccessToken(newToken)
      token = newToken

    } catch (e) {
      console.warn("Refresh falló en request → login de nuevo")
      const tokens = await getNewToken()
      saveTokens(tokens)
      token = tokens.access
    }
  }

  // 3. Aplicamos token (nuevo o existente)
  config.headers.Authorization = "Bearer " + token
  return config
})
/* ============================
   INTERCEPTOR DE RESPONSE
============================ */
api.interceptors.response.use(
  res => res,
  err => Promise.reject(err)
)

export default api
